// Export an array of topics for VA 1st Grade Math
const md5thMathQuizContent = [
  {
    "slug": "placevalue",
    "title": "Place Value",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "What is the value of the 6 in 6,543?",
        "answers": [
          { "text": "6,000", "correct": true },
          { "text": "600", "correct": false },
          { "text": "60", "correct": false }
        ]
      },
      {
        "question": "What is the value of the 5 in 3,582?",
        "answers": [
          { "text": "500", "correct": true },
          { "text": "50", "correct": false },
          { "text": "5", "correct": false }
        ]
      },
      {
        "question": "If you move one place to the left, the value becomes how many times greater?",
        "answers": [
          { "text": "10 times greater", "correct": true },
          { "text": "5 times greater", "correct": false },
          { "text": "2 times greater", "correct": false }
        ]
      },
      {
        "question": "What is the value of the 7 in 47,219?",
        "answers": [
          { "text": "7,000", "correct": true },
          { "text": "700", "correct": false },
          { "text": "70", "correct": false }
        ]
      },
      {
        "question": "If you move one place to the right, the value becomes how many times smaller?",
        "answers": [
          { "text": "10 times smaller", "correct": true },
          { "text": "100 times smaller", "correct": false },
          { "text": "5 times smaller", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "fractionstodecimals",
    "title": "Fractions to Decimals",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "1/2 as a decimal equals?",
        "answers": [
          { "text": "0.5", "correct": true },
          { "text": "0.2", "correct": false },
          { "text": "0.8", "correct": false }
        ]
      },
      {
        "question": "1/4 as a decimal equals?",
        "answers": [
          { "text": "0.25", "correct": true },
          { "text": "0.75", "correct": false },
          { "text": "0.4", "correct": false }
        ]
      },
      {
        "question": "3/4 as a decimal equals?",
        "answers": [
          { "text": "0.75", "correct": true },
          { "text": "0.25", "correct": false },
          { "text": "0.5", "correct": false }
        ]
      },
      {
        "question": "1/5 as a decimal equals?",
        "answers": [
          { "text": "0.2", "correct": true },
          { "text": "0.5", "correct": false },
          { "text": "0.25", "correct": false }
        ]
      },
      {
        "question": "2/5 as a decimal equals?",
        "answers": [
          { "text": "0.4", "correct": true },
          { "text": "0.8", "correct": false },
          { "text": "0.25", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "multiplydecimals",
    "title": "Multiply Decimals",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "0.3 × 0.2 = ?",
        "answers": [
          { "text": "0.06", "correct": true },
          { "text": "0.6", "correct": false },
          { "text": "0.12", "correct": false }
        ]
      },
      {
        "question": "0.4 × 0.5 = ?",
        "answers": [
          { "text": "0.20", "correct": true },
          { "text": "0.9", "correct": false },
          { "text": "0.25", "correct": false }
        ]
      },
      {
        "question": "0.6 × 0.3 = ?",
        "answers": [
          { "text": "0.18", "correct": true },
          { "text": "0.48", "correct": false },
          { "text": "0.9", "correct": false }
        ]
      },
      {
        "question": "0.8 × 0.4 = ?",
        "answers": [
          { "text": "0.32", "correct": true },
          { "text": "0.12", "correct": false },
          { "text": "0.52", "correct": false }
        ]
      },
      {
        "question": "0.7 × 0.2 = ?",
        "answers": [
          { "text": "0.14", "correct": true },
          { "text": "0.12", "correct": false },
          { "text": "0.7", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "dividingdecimals",
    "title": "Dividing Decimals",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "0.6 ÷ 2 = ?",
        "answers": [
          { "text": "0.3", "correct": true },
          { "text": "3", "correct": false },
          { "text": "0.12", "correct": false }
        ]
      },
      {
        "question": "1.2 ÷ 4 = ?",
        "answers": [
          { "text": "0.3", "correct": true },
          { "text": "0.4", "correct": false },
          { "text": "3", "correct": false }
        ]
      },
      {
        "question": "0.8 ÷ 0.2 = ?",
        "answers": [
          { "text": "4", "correct": true },
          { "text": "0.4", "correct": false },
          { "text": "8", "correct": false }
        ]
      },
      {
        "question": "2.4 ÷ 0.3 = ?",
        "answers": [
          { "text": "8", "correct": true },
          { "text": "0.8", "correct": false },
          { "text": "6", "correct": false }
        ]
      },
      {
        "question": "0.9 ÷ 0.3 = ?",
        "answers": [
          { "text": "3", "correct": true },
          { "text": "0.6", "correct": false },
          { "text": "0.03", "correct": false }
        ]
      }
    ]
  },

  {
  "slug": "addsubtractfractions",
  "title": "Add & Subtract Fractions",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "1/4 + 1/4 = ?",
      "answers": [
        { "text": "2/4 or 1/2", "correct": true },
        { "text": "1/8", "correct": false },
        { "text": "3/4", "correct": false }
      ]
    },
    {
      "question": "3/8 + 2/8 = ?",
      "answers": [
        { "text": "5/8", "correct": true },
        { "text": "6/8", "correct": false },
        { "text": "1/8", "correct": false }
      ]
    },
    {
      "question": "5/6 - 1/6 = ?",
      "answers": [
        { "text": "4/6 or 2/3", "correct": true },
        { "text": "5/12", "correct": false },
        { "text": "6/6", "correct": false }
      ]
    },
    {
      "question": "2/3 + 1/3 = ?",
      "answers": [
        { "text": "3/3 or 1 whole", "correct": true },
        { "text": "1/3", "correct": false },
        { "text": "2/6", "correct": false }
      ]
    },
    {
      "question": "7/10 - 3/10 = ?",
      "answers": [
        { "text": "4/10 or 2/5", "correct": true },
        { "text": "5/10", "correct": false },
        { "text": "3/5", "correct": false }
      ]
    }
  ]
},
{
  "slug": "expressions",
  "title": "Expressions",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Which of these is a numerical expression?",
      "answers": [
        { "text": "8 + 4", "correct": true },
        { "text": "x + 5 = 9", "correct": false },
        { "text": "y + 3", "correct": false }
      ]
    },
    {
      "question": "Which of these is an algebraic expression?",
      "answers": [
        { "text": "5 + c", "correct": true },
        { "text": "5 + 2", "correct": false },
        { "text": "7 = 7", "correct": false }
      ]
    },
    {
      "question": "What is the value of 3 × a when a = 4?",
      "answers": [
        { "text": "12", "correct": true },
        { "text": "7", "correct": false },
        { "text": "9", "correct": false }
      ]
    },
    {
      "question": "What is the value of 10 - b when b = 6?",
      "answers": [
        { "text": "4", "correct": true },
        { "text": "16", "correct": false },
        { "text": "6", "correct": false }
      ]
    },
    {
      "question": "Which statement about expressions is true?",
      "answers": [
        { "text": "Expressions do not have equal signs.", "correct": true },
        { "text": "Expressions always have equal signs.", "correct": false },
        { "text": "Expressions only use letters.", "correct": false }
      ]
    }
  ]
},
{
  "slug": "elapsedtime",
  "title": "Elapsed Time",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "If school starts at 8:00 AM and ends at 3:00 PM, how much time has passed?",
      "answers": [
        { "text": "7 hours", "correct": true },
        { "text": "5 hours", "correct": false },
        { "text": "6 hours", "correct": false }
      ]
    },
    {
      "question": "A movie begins at 2:30 PM and ends at 4:00 PM. How long is the movie?",
      "answers": [
        { "text": "1 hour 30 minutes", "correct": true },
        { "text": "2 hours", "correct": false },
        { "text": "1 hour", "correct": false }
      ]
    },
    {
      "question": "If a bus leaves at 9:15 AM and arrives at 10:45 AM, what is the elapsed time?",
      "answers": [
        { "text": "1 hour 30 minutes", "correct": true },
        { "text": "2 hours", "correct": false },
        { "text": "1 hour", "correct": false }
      ]
    },
    {
      "question": "You start reading at 6:10 PM and stop at 6:55 PM. How much time did you read?",
      "answers": [
        { "text": "45 minutes", "correct": true },
        { "text": "30 minutes", "correct": false },
        { "text": "1 hour", "correct": false }
      ]
    },
    {
      "question": "If dinner starts at 5:45 PM and ends at 6:30 PM, how much time passed?",
      "answers": [
        { "text": "45 minutes", "correct": true },
        { "text": "30 minutes", "correct": false },
        { "text": "1 hour", "correct": false }
      ]
    }
  ]
},
{
  "slug": "angles",
  "title": "Angles",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "What is the measure of a right angle?",
      "answers": [
        { "text": "90°", "correct": true },
        { "text": "45°", "correct": false },
        { "text": "120°", "correct": false }
      ]
    },
    {
      "question": "Which type of angle measures less than 90°?",
      "answers": [
        { "text": "Acute angle", "correct": true },
        { "text": "Right angle", "correct": false },
        { "text": "Obtuse angle", "correct": false }
      ]
    },
    {
      "question": "Which type of angle measures more than 90° but less than 180°?",
      "answers": [
        { "text": "Obtuse angle", "correct": true },
        { "text": "Acute angle", "correct": false },
        { "text": "Right angle", "correct": false }
      ]
    },
    {
      "question": "What tool do we use to measure angles?",
      "answers": [
        { "text": "Protractor", "correct": true },
        { "text": "Ruler", "correct": false },
        { "text": "Compass", "correct": false }
      ]
    },
    {
      "question": "What is the point where two rays meet called?",
      "answers": [
        { "text": "Vertex", "correct": true },
        { "text": "Edge", "correct": false },
        { "text": "Corner", "correct": false }
      ]
    }
  ]
},
{
  "slug": "triangles",
  "title": "Triangles",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "How many sides does a triangle have?",
      "answers": [
        { "text": "3", "correct": true },
        { "text": "4", "correct": false },
        { "text": "2", "correct": false }
      ]
    },
    {
      "question": "Which triangle has all sides equal?",
      "answers": [
        { "text": "Equilateral triangle", "correct": true },
        { "text": "Isosceles triangle", "correct": false },
        { "text": "Scalene triangle", "correct": false }
      ]
    },
    {
      "question": "Which triangle has one angle equal to 90°?",
      "answers": [
        { "text": "Right triangle", "correct": true },
        { "text": "Acute triangle", "correct": false },
        { "text": "Obtuse triangle", "correct": false }
      ]
    },
    {
      "question": "Which triangle has one angle greater than 90°?",
      "answers": [
        { "text": "Obtuse triangle", "correct": true },
        { "text": "Right triangle", "correct": false },
        { "text": "Acute triangle", "correct": false }
      ]
    },
    {
      "question": "Which triangle has all sides of different lengths?",
      "answers": [
        { "text": "Scalene triangle", "correct": true },
        { "text": "Equilateral triangle", "correct": false },
        { "text": "Isosceles triangle", "correct": false }
      ]
    }
  ]
},
{
  "slug": "2timestable",
  "title": "2 Times Table",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "2 × 3 = ?",
      "answers": [
        { "text": "6", "correct": true },
        { "text": "5", "correct": false },
        { "text": "8", "correct": false }
      ]
    },
    {
      "question": "2 × 5 = ?",
      "answers": [
        { "text": "10", "correct": true },
        { "text": "8", "correct": false },
        { "text": "12", "correct": false }
      ]
    },
    {
      "question": "2 × 7 = ?",
      "answers": [
        { "text": "14", "correct": true },
        { "text": "12", "correct": false },
        { "text": "16", "correct": false }
      ]
    },
    {
      "question": "2 × 9 = ?",
      "answers": [
        { "text": "18", "correct": true },
        { "text": "20", "correct": false },
        { "text": "16", "correct": false }
      ]
    },
    {
      "question": "2 × 12 = ?",
      "answers": [
        { "text": "24", "correct": true },
        { "text": "22", "correct": false },
        { "text": "26", "correct": false }
      ]
    }
  ]
},
{
  "slug": "3timestable",
  "title": "3 Times Table",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "3 × 2 = ?",
      "answers": [
        { "text": "6", "correct": true },
        { "text": "5", "correct": false },
        { "text": "9", "correct": false }
      ]
    },
    {
      "question": "3 × 4 = ?",
      "answers": [
        { "text": "12", "correct": true },
        { "text": "9", "correct": false },
        { "text": "15", "correct": false }
      ]
    },
    {
      "question": "3 × 6 = ?",
      "answers": [
        { "text": "18", "correct": true },
        { "text": "15", "correct": false },
        { "text": "12", "correct": false }
      ]
    },
    {
      "question": "3 × 8 = ?",
      "answers": [
        { "text": "24", "correct": true },
        { "text": "27", "correct": false },
        { "text": "21", "correct": false }
      ]
    },
    {
      "question": "3 × 12 = ?",
      "answers": [
        { "text": "36", "correct": true },
        { "text": "30", "correct": false },
        { "text": "33", "correct": false }
      ]
    }
  ]
},
{
  "slug": "4timestable",
  "title": "4 Times Table",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "4 × 3 = ?",
      "answers": [
        { "text": "12", "correct": true },
        { "text": "8", "correct": false },
        { "text": "16", "correct": false }
      ]
    },
    {
      "question": "4 × 5 = ?",
      "answers": [
        { "text": "20", "correct": true },
        { "text": "24", "correct": false },
        { "text": "16", "correct": false }
      ]
    },
    {
      "question": "4 × 7 = ?",
      "answers": [
        { "text": "28", "correct": true },
        { "text": "24", "correct": false },
        { "text": "30", "correct": false }
      ]
    },
    {
      "question": "4 × 9 = ?",
      "answers": [
        { "text": "36", "correct": true },
        { "text": "32", "correct": false },
        { "text": "40", "correct": false }
      ]
    },
    {
      "question": "4 × 12 = ?",
      "answers": [
        { "text": "48", "correct": true },
        { "text": "44", "correct": false },
        { "text": "42", "correct": false }
      ]
    }
  ]
},
{
  "slug": "5timestable",
  "title": "5 Times Table",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "5 × 3 = ?",
      "answers": [
        { "text": "15", "correct": true },
        { "text": "10", "correct": false },
        { "text": "20", "correct": false }
      ]
    },
    {
      "question": "5 × 4 = ?",
      "answers": [
        { "text": "20", "correct": true },
        { "text": "15", "correct": false },
        { "text": "25", "correct": false }
      ]
    },
    {
      "question": "5 × 6 = ?",
      "answers": [
        { "text": "30", "correct": true },
        { "text": "25", "correct": false },
        { "text": "35", "correct": false }
      ]
    },
    {
      "question": "5 × 8 = ?",
      "answers": [
        { "text": "40", "correct": true },
        { "text": "35", "correct": false },
        { "text": "45", "correct": false }
      ]
    },
    {
      "question": "5 × 12 = ?",
      "answers": [
        { "text": "60", "correct": true },
        { "text": "55", "correct": false },
        { "text": "65", "correct": false }
      ]
    }
  ]
},
{
  "slug": "6timestable",
  "title": "6 Times Table",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "6 × 3 = ?",
      "answers": [
        { "text": "18", "correct": true },
        { "text": "12", "correct": false },
        { "text": "24", "correct": false }
      ]
    },
    {
      "question": "6 × 4 = ?",
      "answers": [
        { "text": "24", "correct": true },
        { "text": "18", "correct": false },
        { "text": "30", "correct": false }
      ]
    },
    {
      "question": "6 × 5 = ?",
      "answers": [
        { "text": "30", "correct": true },
        { "text": "24", "correct": false },
        { "text": "36", "correct": false }
      ]
    },
    {
      "question": "6 × 7 = ?",
      "answers": [
        { "text": "42", "correct": true },
        { "text": "48", "correct": false },
        { "text": "36", "correct": false }
      ]
    },
    {
      "question": "6 × 9 = ?",
      "answers": [
        { "text": "54", "correct": true },
        { "text": "60", "correct": false },
        { "text": "48", "correct": false }
      ]
    }
  ]
},
{
  "slug": "7timestable",
  "title": "7 Times Table",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "7 × 2 = ?",
      "answers": [
        { "text": "14", "correct": true },
        { "text": "12", "correct": false },
        { "text": "16", "correct": false }
      ]
    },
    {
      "question": "7 × 3 = ?",
      "answers": [
        { "text": "21", "correct": true },
        { "text": "24", "correct": false },
        { "text": "18", "correct": false }
      ]
    },
    {
      "question": "7 × 5 = ?",
      "answers": [
        { "text": "35", "correct": true },
        { "text": "28", "correct": false },
        { "text": "42", "correct": false }
      ]
    },
    {
      "question": "7 × 8 = ?",
      "answers": [
        { "text": "56", "correct": true },
        { "text": "63", "correct": false },
        { "text": "49", "correct": false }
      ]
    },
    {
      "question": "7 × 12 = ?",
      "answers": [
        { "text": "84", "correct": true },
        { "text": "77", "correct": false },
        { "text": "91", "correct": false }
      ]
    }
  ]
},
{
  "slug": "8timestable",
  "title": "8 Times Table",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "8 × 2 = ?",
      "answers": [
        { "text": "16", "correct": true },
        { "text": "18", "correct": false },
        { "text": "14", "correct": false }
      ]
    },
    {
      "question": "8 × 3 = ?",
      "answers": [
        { "text": "24", "correct": true },
        { "text": "28", "correct": false },
        { "text": "32", "correct": false }
      ]
    },
    {
      "question": "8 × 5 = ?",
      "answers": [
        { "text": "40", "correct": true },
        { "text": "48", "correct": false },
        { "text": "56", "correct": false }
      ]
    },
    {
      "question": "8 × 7 = ?",
      "answers": [
        { "text": "56", "correct": true },
        { "text": "64", "correct": false },
        { "text": "48", "correct": false }
      ]
    },
    {
      "question": "8 × 12 = ?",
      "answers": [
        { "text": "96", "correct": true },
        { "text": "88", "correct": false },
        { "text": "104", "correct": false }
      ]
    }
  ]
},
{
  "slug": "9timestable",
  "title": "9 Times Table",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "9 × 2 = ?",
      "answers": [
        { "text": "18", "correct": true },
        { "text": "16", "correct": false },
        { "text": "20", "correct": false }
      ]
    },
    {
      "question": "9 × 4 = ?",
      "answers": [
        { "text": "36", "correct": true },
        { "text": "32", "correct": false },
        { "text": "27", "correct": false }
      ]
    },
    {
      "question": "9 × 5 = ?",
      "answers": [
        { "text": "45", "correct": true },
        { "text": "40", "correct": false },
        { "text": "54", "correct": false }
      ]
    },
    {
      "question": "9 × 7 = ?",
      "answers": [
        { "text": "63", "correct": true },
        { "text": "72", "correct": false },
        { "text": "54", "correct": false }
      ]
    },
    {
      "question": "9 × 12 = ?",
      "answers": [
        { "text": "108", "correct": true },
        { "text": "99", "correct": false },
        { "text": "112", "correct": false }
      ]
    }
  ]
},
{
  "slug": "10timestable",
  "title": "10 Times Table",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "10 × 2 = ?",
      "answers": [
        { "text": "20", "correct": true },
        { "text": "10", "correct": false },
        { "text": "30", "correct": false }
      ]
    },
    {
      "question": "10 × 4 = ?",
      "answers": [
        { "text": "40", "correct": true },
        { "text": "30", "correct": false },
        { "text": "50", "correct": false }
      ]
    },
    {
      "question": "10 × 6 = ?",
      "answers": [
        { "text": "60", "correct": true },
        { "text": "50", "correct": false },
        { "text": "70", "correct": false }
      ]
    },
    {
      "question": "10 × 8 = ?",
      "answers": [
        { "text": "80", "correct": true },
        { "text": "70", "correct": false },
        { "text": "90", "correct": false }
      ]
    },
    {
      "question": "10 × 12 = ?",
      "answers": [
        { "text": "120", "correct": true },
        { "text": "100", "correct": false },
        { "text": "110", "correct": false }
      ]
    }
  ]
},
{
  "slug": "11timestable",
  "title": "11 Times Table",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "11 × 2 = ?",
      "answers": [
        { "text": "22", "correct": true },
        { "text": "21", "correct": false },
        { "text": "24", "correct": false }
      ]
    },
    {
      "question": "11 × 4 = ?",
      "answers": [
        { "text": "44", "correct": true },
        { "text": "42", "correct": false },
        { "text": "48", "correct": false }
      ]
    },
    {
      "question": "11 × 6 = ?",
      "answers": [
        { "text": "66", "correct": true },
        { "text": "64", "correct": false },
        { "text": "60", "correct": false }
      ]
    },
    {
      "question": "11 × 8 = ?",
      "answers": [
        { "text": "88", "correct": true },
        { "text": "80", "correct": false },
        { "text": "99", "correct": false }
      ]
    },
    {
      "question": "11 × 12 = ?",
      "answers": [
        { "text": "132", "correct": true },
        { "text": "121", "correct": false },
        { "text": "142", "correct": false }
      ]
    }
  ]
},
{
  "slug": "12timestable",
  "title": "12 Times Table",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "12 × 2 = ?",
      "answers": [
        { "text": "24", "correct": true },
        { "text": "22", "correct": false },
        { "text": "26", "correct": false }
      ]
    },
    {
      "question": "12 × 4 = ?",
      "answers": [
        { "text": "48", "correct": true },
        { "text": "42", "correct": false },
        { "text": "52", "correct": false }
      ]
    },
    {
      "question": "12 × 6 = ?",
      "answers": [
        { "text": "72", "correct": true },
        { "text": "68", "correct": false },
        { "text": "78", "correct": false }
      ]
    },
    {
      "question": "12 × 8 = ?",
      "answers": [
        { "text": "96", "correct": true },
        { "text": "92", "correct": false },
        { "text": "100", "correct": false }
      ]
    },
    {
      "question": "12 × 12 = ?",
      "answers": [
        { "text": "144", "correct": true },
        { "text": "132", "correct": false },
        { "text": "156", "correct": false }
      ]
    }
  ]
},
]

export default md5thMathQuizContent;
